module.exports = __webpack_public_path__ + "static/media/ex-mobile-apps-icon1.762d1f19.svg";